import { SessionType } from './SessionType';
import { isWizard } from './isWizard';

/**
 * Wizard-only testing tools: a wizard session, or a wizard in client view looking at their own
 * client profile. Unlike `isWizardSession`, it doesn't turn client view into the wizard UI.
 */
export function canUseWizardTestTools(session: Session | null | undefined): boolean {
  return isWizardSession(session) || !!session?.isWizardInClientView;
}

/**
 * Check if a session belongs to a wizard user.
 * Unlike `isWizard(session.advisor)`, this works correctly during impersonation
 * because `sessionType` stays `wizard` even when the advisor is swapped.
 */
export function isWizardSession(session: Session | null | undefined): boolean {
  if (!session) return false;
  return (
    session.sessionType === SessionType.wizard ||
    (session.advisor != null && isWizard(session.advisor))
  );
}
